(() => {
  if (window.__pinrshelfLeadTrackingLoaded || window.Shopify?.designMode) return;
  window.__pinrshelfLeadTrackingLoaded = true;

  const storageKey = 'pinrshelf:pending-quote:v1';
  const allowedTypes = new Set(['home_project', 'product_bulk', 'contact']);
  const maxAge = 2 * 60 * 60 * 1000;
  const documentId = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`;
  let privacyLoading = false;
  let privacyAttempted = false;
  let timer;
  let attempts = 0;

  const analyticsAllowed = () => {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
    } catch {
      return false;
    }
  };

  const clearPending = () => {
    try {
      window.sessionStorage.removeItem(storageKey);
      return true;
    } catch {
      return false;
    }
  };

  const readPending = () => {
    try {
      const value = JSON.parse(window.sessionStorage.getItem(storageKey));
      if (!value || !allowedTypes.has(value.formType)) return null;
      if (!/^[A-Za-z0-9_-]{1,200}$/.test(value.formId)) return null;
      if (typeof value.pagePath !== 'string' || !value.pagePath.startsWith('/')) return null;
      if (!Number.isFinite(value.createdAt) || Date.now() - value.createdAt > maxAge) return null;
      if (value.createdAt > Date.now() || typeof value.documentId !== 'string') return null;
      return value;
    } catch {
      return null;
    }
  };

  const retry = () => {
    if (timer || attempts >= 40) return;
    attempts += 1;
    timer = window.setTimeout(() => {
      timer = null;
      publishSuccess();
    }, 250);
  };

  const loadPrivacy = () => {
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed) return;
    if (privacyLoading || privacyAttempted || !window.Shopify?.loadFeatures) return;
    privacyLoading = true;
    privacyAttempted = true;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
      privacyLoading = false;
      if (!error) publishSuccess();
    });
  };

  const publishSuccess = () => {
    if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed) {
      loadPrivacy();
      retry();
      return;
    }
    if (!analyticsAllowed()) {
      clearPending();
      return;
    }
    const pending = readPending();
    if (!pending || pending.documentId === documentId) return;
    if (pending.pagePath !== window.location.pathname) return;
    const marker = Array.from(document.querySelectorAll('[data-pinrshelf-quote-success]')).find(item =>
      item.dataset.formId === pending.formId &&
      item.dataset.formType === pending.formType &&
      item.dataset.pagePath === pending.pagePath
    );
    if (!marker) return;
    if (typeof window.Shopify?.analytics?.publish !== 'function') {
      retry();
      return;
    }
    const payload = {
      form_type: pending.formType,
      form_id: pending.formId,
      page_path: pending.pagePath,
    };
    if (/^\d+$/.test(marker.dataset.productId || '')) payload.product_id = marker.dataset.productId;
    if (!clearPending()) return;
    try {
      Promise.resolve(window.Shopify.analytics.publish('pinrshelf_quote_submitted', payload)).catch(() => {});
    } catch {}
  };

  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form?.matches?.('form[data-pinrshelf-quote-form]') || !analyticsAllowed()) return;
    const formType = form.dataset.pinrshelfQuoteForm;
    if (!allowedTypes.has(formType) || !/^[A-Za-z0-9_-]{1,200}$/.test(form.id || '')) return;
    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify({
        formType,
        formId: form.id,
        pagePath: window.location.pathname,
        createdAt: Date.now(),
        documentId,
      }));
    } catch {}
  }, true);

  document.addEventListener('visitorConsentCollected', () => {
    if (analyticsAllowed()) publishSuccess();
    else clearPending();
  });
  document.addEventListener('shopify:section:load', publishSuccess);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', publishSuccess, { once: true });
  else publishSuccess();
})();
